'use client';
import { CmsImage } from '@hyphengroup/cms-components/components/CmsImage';
import { useBreakpoint } from 'car-insurance/hooks/useBreakpoint';
import React from 'react';
import { ComponentSectionalHeader } from '$/(cms)/_modules/cmsService/types';

export const SectionalHeader: React.FC<ComponentSectionalHeader> = ({
  visible,
  title,
  subtitle,
  level = 'h2',
  image,
}) => {
  const isMobile = useBreakpoint() === 'sm';
  if (!visible) return null;

  const renderTitle = () => {
    const tag = level;
    return React.createElement(
      tag,
      {
        className: `mhg-alpha-typography-display-1 text-text/primary 
        ${isMobile && image?.url ? 'mb-spacing/gap/y-sm' : ''}`,
      },
      title,
    );
  };

  return isMobile ? (
    <div className="flex flex-col">
      <div className={image?.url ? 'relative' : ''}>
        {image?.url && (
          <div
            className="float-right ml-spacing/gap/x"
            style={{ shapeOutside: 'margin-box' }}
          >
            <CmsImage
              unoptimized
              src={image.url}
              alt="Sectional Header image"
              height={168}
              width={168}
              className="size-32 object-cover"
            />
          </div>
        )}
        {renderTitle()}
        {subtitle && (
          <p className="mhg-alpha-typography-body-1 text-colors/neutral-gray-800 leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  ) : (
    <div className="flex flex-row items-start gap-spacing/gap/y">
      <div className="flex flex-col gap-spacing/gap/x">
        {renderTitle()}
        {subtitle && (
          <span className="mhg-alpha-typography-body-1 text-colors/neutral-gray-800 leading-line-height/body-1-relaxed">
            {subtitle}
          </span>
        )}
      </div>
      {image?.url && (
        <CmsImage
          unoptimized
          src={image.url}
          alt="Sectional Header image"
          height={168}
          width={168}
          className="size-42 object-cover"
        />
      )}
    </div>
  );
};
// for commit
